import { useMemo } from 'react';
import type { DependencyRecord } from '@mm-shared/dependencies';

export type ResultTypeFilter = 'all' | 'key' | 'not-key';
export type LocationFilter = 'all' | 'cross-map' | 'this-map';

export function useFilteredDependencyRecords(
  records: DependencyRecord[],
  options: {
    resultType?: ResultTypeFilter;
    location?: LocationFilter;
    mapUuid: string;
  },
): DependencyRecord[] {
  const { resultType = 'all', location = 'all', mapUuid } = options;
  return useMemo(() => {
    let filtered = records;
    // Filter by result type
    if (resultType === 'key') {
      filtered = filtered.filter((rec) => rec.sourceResult.isKeyResult);
    } else if (resultType === 'not-key') {
      filtered = filtered.filter((rec) => !rec.sourceResult.isKeyResult);
    }
    // Filter by location
    if (location === 'cross-map') {
      filtered = filtered.filter((rec) => rec.sourceMap.uuid !== rec.targetMap.uuid);
    } else if (location === 'this-map') {
      filtered = filtered.filter(
        (rec) => rec.sourceMap.uuid === rec.targetMap.uuid && rec.sourceMap.uuid === mapUuid,
      );
    }
    return filtered;
  }, [records, resultType, location, mapUuid]);
}
